var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#FFF", padding: "10px 20px 20px 20px" } },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { position: "relative" },
          attrs: { model: _vm.form, inline: true },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "创建时间", prop: "create_time" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "380px" },
                attrs: {
                  type: "datetimerange",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm:ss",
                  "default-time": ["00:00:00", "23:59:59"],
                  align: "right",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.create_time,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "create_time", $$v)
                  },
                  expression: "form.create_time",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "下载类型", prop: "download_type" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.download_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "download_type", $$v)
                    },
                    expression: "form.download_type",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _vm._v(" "),
                  _vm._l(_vm.download_type_list, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                _vm._l(_vm.statusList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "有效/无效", prop: "is_valid" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "80px" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.is_valid,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "is_valid", $$v)
                    },
                    expression: "form.is_valid",
                  },
                },
                _vm._l(_vm.validList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchList } },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.clearForm } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { position: "absolute", right: "0" },
              attrs: { type: "danger" },
              on: { click: _vm.searchList },
            },
            [_vm._v("刷新")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": { background: "#F1F1F1", color: "#333333" },
            data: _vm.dataList,
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "文件名称", prop: "file_name", align: "left" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "下载类型",
              prop: "download_type_cn",
              width: "190px",
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "文件格式",
              prop: "file_format",
              align: "left",
              width: "80px",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "文件大小",
              prop: "file_size",
              align: "left",
              width: "90px",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建时间", width: "160px", prop: "created_time" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "status_cn",
              align: "left",
              width: "140px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === "0"
                      ? _c("el-tag", [_vm._v("文件生成中")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === "1" && scope.row.is_valid === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v(
                            "文件已生成(" +
                              _vm._s(scope.row.is_valid === 1 ? "有效" : "") +
                              ")"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === "1" && scope.row.is_valid === 2
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v(
                            "文件已生成(" +
                              _vm._s(scope.row.is_valid === 2 ? "失效" : "") +
                              ")"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === "2"
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("生成失败"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "下载人",
              prop: "creator_name",
              align: "left",
              width: "100px",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "left", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === "1" &&
                    scope.row.is_valid === 1 &&
                    _vm.$hasBtnRoles("/user/user-download/list")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.downLoadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v("下载到本地")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === "0" &&
                    _vm.$hasBtnRoles("/user/user-download/del-my-record")
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n        删除任务\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "20px 0" } },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next, jumper",
              "page-size": 20,
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.currentPage,
            },
            on: { "current-change": _vm.currentChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }